import { DOC_VERSION, type AlbumDocument } from './schema';
import { parseAlbumDocument } from './helpers';

/** Each step upgrades a raw document object from version N to N+1. Add entries as DOC_VERSION grows. */
type Migration = (raw: Record<string, unknown>) => Record<string, unknown>;
const MIGRATIONS: Record<number, Migration> = {
  // 1: (raw) => ({ ...raw, version: 2, ... }),
};

export class MigrationError extends Error {
  override name = 'MigrationError';
}

/**
 * Bring a stored document (any supported version) up to DOC_VERSION and validate it.
 * Throws MigrationError for unknown versions and ZodError for invalid content.
 */
export function migrateDocument(input: unknown): AlbumDocument {
  if (typeof input !== 'object' || input === null || Array.isArray(input)) throw new MigrationError('document must be an object');
  let raw = input as Record<string, unknown>;
  let version = typeof raw.version === 'number' ? raw.version : 0;
  if (version < 1 || version > DOC_VERSION) throw new MigrationError(`unsupported document version ${String(raw.version)}`);
  while (version < DOC_VERSION) {
    const step = MIGRATIONS[version];
    if (!step) throw new MigrationError(`no migration from version ${version}`);
    raw = step(raw);
    version += 1;
  }
  return parseAlbumDocument(raw);
}
